export default __webpack_public_path__ + "static/piplup2-1109ee4e068431723ca3adee13102a70.webp";